module.exports = __webpack_public_path__ + "img/20171229_172804.77fa3489.jpg";